import React from 'react';
import PropTypes from 'prop-types';

const AirplaneSeatIcon = ({ className, color }) => (
  <svg
    className={className}
    width='33px'
    height='25px'
    viewBox='0 0 33 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='seat' className='seatImage' fill='#EEEEF0'>
        <rect
          id='Rectangle-2'
          transform='translate(16.500000, 9.278879) rotate(-270.000000) translate(-16.500000, -9.278879) '
          x='7.61538462'
          y='-1.20186831'
          width='17.7692308'
          height='20.9614946'
          rx='2'
        />
        <rect
          id='Rectangle-2-Copy-12'
          transform='translate(17.134615, 22.379813) rotate(-270.000000) translate(-17.134615, -22.379813) '
          x='15.2307692'
          y='9.27887902'
          width='3.80769231'
          height='26.2018683'
          rx='1.90384615'
        />
        <rect
          id='Rectangle-2-Copy-13'
          transform='translate(31.096154, 10.588972) rotate(-360.000000) translate(-31.096154, -10.588972) '
          x='29.1923077'
          y='4.03850535'
          width='3.80769231'
          height='13.1009342'
          rx='1.90384615'
        />
        <rect
          id='Rectangle-2-Copy-110'
          transform='translate(1.903846, 10.588972) rotate(-360.000000) translate(-1.903846, -10.588972) '
          x='0'
          y='4.03850535'
          width='3.80769231'
          height='13.1009342'
          rx='1.90384615'
        />
      </g>
    </g>
  </svg>
);

AirplaneSeatIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default AirplaneSeatIcon;



// WEBPACK FOOTER //
// ./src/icons/AirplaneSeatIcon.js